import { useZustandLocation } from "@faire/retailer/app/_lib/routing/useZustandLocation";
import { useSearchPageQueryParams } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";

export const useSearchPageProductSearchString = () => {
  const { pathname } = useZustandLocation((state) => state.pathname);
  const query = useSearchPageQueryParams().searchQuery;

  return pathname.startsWith("/brand") ? "" : query;
};
